
(function() {
  var result = { translations: { "ko": { "i18n": { "dateTime": { "quarterAndYear": "{{yearNumber}} {{quarterNumber}}\uBD84\uAE30" }, "duration": { "days": "{{ days }}\uC77C", "hours": "{{ hours }}\uC2DC\uAC04", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84", "minutes": "{{ minutes }}\uBD84", "seconds": "{{ seconds }}\uCD08", "shortForm": { "days": "{{ days }}\uC77C", "hours": "{{ hours }}\uC2DC\uAC04", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84", "minutes": "{{ minutes }}\uBD84", "seconds": "{{ seconds }}\uCD08" } }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \uB0B4\uC120\uBC88\uD638: {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ko": "static-7.985"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.985",
    "ar-eg": "static-7.985",
    "bg": "static-7.985",
    "bn": "static-7.985",
    "ca-es": "static-7.985",
    "cs": "static-7.985",
    "da": "static-7.985",
    "de": "static-7.985",
    "el": "static-7.985",
    "en-gb": "static-7.985",
    "en": "static-7.985",
    "es-mx": "static-7.985",
    "es": "static-7.985",
    "fi": "static-7.985",
    "fr-ca": "static-7.985",
    "fr": "static-7.985",
    "he-il": "static-7.985",
    "hr": "static-7.985",
    "hu": "static-7.985",
    "id": "static-7.985",
    "it": "static-7.985",
    "ja": "static-7.985",
    "ko": "static-7.985",
    "lt": "static-7.985",
    "ms": "static-7.985",
    "nl": "static-7.985",
    "no": "static-7.985",
    "pl": "static-7.985",
    "pt-br": "static-7.985",
    "pt-pt": "static-7.985",
    "ro": "static-7.985",
    "ru": "static-7.985",
    "sk": "static-7.985",
    "sl": "static-7.985",
    "sv": "static-7.985",
    "th": "static-7.985",
    "tl": "static-7.985",
    "tr": "static-7.985",
    "uk": "static-7.985",
    "vi": "static-7.985",
    "x-pseudo": "static-7.985",
    "zh-cn": "static-7.985",
    "zh-hk": "static-7.985",
    "zh-tw": "static-7.985"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ko', {version: 'static-7.985'}); }
})();


